import { render, staticRenderFns } from "./my-wishlist-all-products.vue?vue&type=template&id=6901b500"
import script from "./my-wishlist-all-products.vue?vue&type=script&lang=js"
export * from "./my-wishlist-all-products.vue?vue&type=script&lang=js"
import style0 from "./my-wishlist-all-products.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports